// extracted by css-extract-rspack-plugin
export default {"cls1":"PingAnswerStyles-cls1_-th","cls2":"PingAnswerStyles-cls2_c-P PingAnswerStyles-cls1_-th"};